<template>
  <v-container fluid style="height: 100vh;">
    <v-layout column fill-height>
      <v-row class="flex-grow-0">
        <v-list-item>
          <v-list-item-content class="list-item-content-edit">

            <v-text-field
              :label="$t('common.vehicle_filter')"
              clearable
              v-model="vehicleFilter"
              hide-details
            >
              <template v-slot:append>
                <v-tooltip bottom open-delay="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      icon
                      style="margin-top: 2px"
                      v-bind="attrs"
                      v-on="on"
                      @click="onShowFiltered"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("map.panel.online.tooltip.show_all") }}</span>
                </v-tooltip>

                <v-tooltip bottom open-delay="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      icon
                      class="ml-1"
                      style="margin-top: 2px"
                      v-bind="attrs"
                      v-on="on"
                      @click="onHideFiltered"
                    >
                      <v-icon>mdi-eye-off</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("map.panel.online.tooltip.hide_all") }}</span>
                </v-tooltip>

              </template>
            </v-text-field>
          </v-list-item-content>
        </v-list-item>
      </v-row>

      <v-row class="overflow-y-auto" style="max-height: 100%">
        <v-virtual-scroll :items="filteredVehicles" bench="2" min-height="120px" max-height="100vh" item-height="80px">
          <template v-slot:default="{ item }">
            <v-list-item :key="'side-vehicle-' + item.vehicleId" @click="onClickVehicle(item)" class="py-1">
              <v-list-item-content class="list-item-content">
                <v-list-item-title>
                  <span style="padding-right: 5px">{{ item.numericPlate }}</span>
                  <v-icon v-if="getVehicleIcon(item) === 'navigation'" small :class="getVehicleIconColor(item)"
                          :style="getStyleRotate(item) + ';margin: 0'">navigation
                  </v-icon>
                  <v-icon v-else-if="getVehicleIcon(item) === 'circle'" x-small :class="getVehicleIconColor(item)"
                          style="padding-bottom: 2px">circle
                  </v-icon>
                  <v-icon v-else x-small :class="getVehicleIconColor(item)" style="padding-bottom: 2px">square</v-icon>
                  <span class="vname" style="padding: 5px 4px">{{ getVehicleName(item) }}</span>

                  <span style="float: right">
                    <v-tooltip bottom open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          :disabled="item.location === null"
                          @click.stop="onAction('action-visibility', item)"
                        >
                          <v-icon v-if="$store.getters['online/isVisible'](item)">mdi-eye</v-icon>
                          <v-icon v-else>mdi-eye-off</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("map.panel.online.tooltip.show_hide") }}</span>
                    </v-tooltip>

                    <v-tooltip bottom open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="item.location === null"
                          @click.stop="onAction('action-vehicle', item)"
                        >
                          <v-icon>mdi-crosshairs-gps</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("map.panel.tooltip.vehicle") }}</span>
                    </v-tooltip>

                    <v-tooltip bottom open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="item.location === null"
                          @click.stop="onAction('action-history', item)"
                        >
                          <v-icon>mdi-history</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("map.panel.tooltip.history") }}</span>
                    </v-tooltip>

                    <v-menu offset-y z-index="4000">
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-tooltip bottom open-delay="500">
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                              x-small
                              icon
                              class="ml-1"
                              v-bind="attrs"
                              v-on="{ ...tooltip, ...menu }"
                            >
                            <v-icon>more_vert</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("map.panel.online.tooltip.more") }}</span>
                        </v-tooltip>
                      </template>
                      <v-list>
                        <template v-for="menuItem in getMenuActions(item)">
                          <v-divider v-if="menuItem.border" :key="menuItem.name + '-div'" class="mx-3" />
                          <v-list-item
                            :key="menuItem.name"
                            link
                            :disabled="menuItem.needLocation && item.location === null"
                            @click="onAction(menuItem.name, item)"
                          >
                            <v-list-item-icon style="margin-right: 10px"><v-icon :class="{'red--text': menuItem.importent}">{{ menuItem.icon
                              }}</v-icon></v-list-item-icon>
                            <v-list-item-title :class="{'font-weight-bold': menuItem.importent}">{{ menuItem.title }}</v-list-item-title>
                            </v-list-item>
                          <v-divider v-if="menuItem.borderBottom" :key="menuItem.name + '-div2'" class="mx-3" />
                          </template>
                      </v-list>
                    </v-menu>
                  </span>
                </v-list-item-title>

                <v-list-item-subtitle class="list-item-subtitle">
                  <span
                    v-if="item.flagService !== null || item.flagPanic !== null || item.flagCargoDoor !== null">
                    <span v-if="item.flagPanic !== null" class="flag_panic">{{ $t("common.panic") }}</span>
                    <span v-if="item.flagCargoDoor !== null" class="flag_door">{{ $t("common.door") }}</span>
                    <span v-if="item.flagService !== null">
                      <span v-if="item.flagService" :class="'service_warning'">{{ $t("map.panel.online.service") }}</span>
                      <span v-else :class="'service_notice'">{{ $t("map.panel.online.service") }}</span>
                    </span>
                    <span class="grey--text">&nbsp;•&nbsp;</span>
                  </span>
                  <template v-if="item.ride !== null">
                    <span v-if="isDriver(item)">{{ getDriver(item) }}<span
                      class="grey--text">&nbsp;•&nbsp;</span></span>
                    <span class="font-italic">{{ $t("enum.ride_type." + item.ride.rideType) }}</span>
                  </template>
                  <span v-else>-</span>
                </v-list-item-subtitle>

                <v-list-item-subtitle class="list-item-subtitle">
                  <template v-if="item.location !== null">
                    <country-flag class="small-flag-move" v-if="getLocationPlaceFlag(item)"
                                  :country="getLocationPlaceFlag(item)" size="small" />
                    <span style="padding-left: 5px">{{ getLocationPlace(item) }}</span>
                  </template>
                  <span v-else>-</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mx-2" :key="'side-vehicle-divider-' + item.vehicleId" />
          </template>
        </v-virtual-scroll>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import utils from "@/utils";

export default {
  name: "SideOnline",

  props: {
    vehicleSidebarClick: {}
  },

  data() {
    return {
      vehicleFilter: this.$store.state.online.filter,
      moreActions: [
        {
          name: "reset-panic",
          icon: "priority_high",
          title: this.$t("table.vehicles.context-menu.reset-panic"),
          needLocation: false,
          borderBottom: true,
          importent: true,
          condition: (vehicle) => vehicle.flagPanic !== null
        },
        {
          name: "action-logbook",
          icon: "mdi-text-box-outline",
          title: this.$t("table.vehicles.context-menu.logbook"),
          needLocation: true
        },
        {
          name: "action-refueling",
          icon: "local_gas_station",
          title: this.$t("table.vehicles.context-menu.refueling"),
          needLocation: true
        },
        {
          name: "action-events",
          icon: "event_available",
          title: this.$t("table.vehicles.context-menu.events"),
          needLocation: false
        },
        {
          name: "action-service",
          icon: "build",
          title: this.$t("table.vehicles.context-menu.service"),
          needLocation: true,
          module: "service"
        },
        {
          name: "action-contracts",
          icon: "widgets",
          title: this.$t("table.vehicles.context-menu.contracts"),
          needLocation: true,
          module: "contract"
        },
        {
          name: "report-logbook",
          title: this.$t("table.vehicles.context-menu.report-logbook"),
          border: true,
          needLocation: true
        },
        {
          name: "report-performance",
          title: this.$t("table.vehicles.context-menu.report-performance"),
          machine: false,
          needLocation: true
        },
        {
          name: "report-machine-performance",
          title: this.$t("table.vehicles.context-menu.report-machine-performance"),
          machine: true,
          needLocation: true
        },
        {
          name: "vehicle-update",
          icon: "edit_square",
          title: this.$t("map.panel.online.action.vehicle_update"),
          border: true,
          role: "dispatcher",
          needLocation: false
        },
        {
          name: "vehicle-edit",
          icon: "edit",
          title: this.$t("map.panel.online.action.vehicle_edit"),
          role: "superuser",
          needLocation: false
        }
      ]
    };
  },

  methods: {
    getVehicleName(vehicle) {
      if (vehicle.name.length <= 14)
        return vehicle.name;
      else
        return vehicle.name.substring(0, 14) + "...";
    },

    getVehicleIconColor(vehicle) {
      switch (utils.vehicleState(vehicle)) {
        case "ACTIVE":
          if (vehicle.ride !== null && vehicle.ride.rideState === "unfinished")
            return "blue--text";
          else
            return "";
        case "NEW":
          return "blue-grey--text text--lighten-2";
        default:
          return "red--text text--lighten-2";
      }
    },

    getStyleRotate(vehicle) {
      return "transform: rotate(" + vehicle.location.direction + "deg)";
    },

    getVehicleIcon(vehicle) {
      if (vehicle.ride !== null && vehicle.ride.rideState === "unfinished") {
        if (vehicle.location.speed >= 5) {
          return "navigation";
        } else {
          return "circle";
        }
      } else {
        return "square";
      }
    },

    onClickVehicle(event) {
      this.$emit("clicked", event);
    },

    onShowFiltered() {
      this.$emit("show-filtered");
    },

    onHideFiltered() {
      this.$emit("hide-filtered");
    },

    onAction(action, vehicle) {
      switch (action) {
        case "report-logbook":
          this.$router.push({
            name: "report/logbook",
            params: { ccode: this.$store.state.auth.company.code },
            query: { "vehicleId": vehicle.vehicleId, "periodName": "month-current" }
          });
          break;

        case "report-performance":
          this.$router.push({
            name: "report/performance",
            params: { ccode: this.$store.state.auth.company.code },
            query: { "vehicleId": vehicle.vehicleId, "periodName": "month-current" }
          });
          break;

        case "report-machine-performance":
          this.$router.push({
            name: "report/machine-performance",
            params: { ccode: this.$store.state.auth.company.code },
            query: { "vehicleId": vehicle.vehicleId, "periodName": "month-current" }
          });
          break;

        case "vehicle-update":
          this.$store.dispatch("dialogs/showDialog", { dialog: "vehicleUpdate", options: vehicle });
          break;

        case "vehicle-edit":
          this.$router.replace({
            name: "data/vehicle",
            params: { ccode: this.$store.state.auth.company.code, id: vehicle.vehicleId }
          });
          break;

        case "reset-panic":
          this.$store.dispatch("data/resetFlag", { ccode: this.$store.state.auth.company.code, vehicleId: vehicle.vehicleId, flag: 'panic' });
          break;

        default:
          this.$emit(action, vehicle);
      }
    },

    getMenuActions(vehicle) {
      const machine = vehicle.typeCode === "machine";

      return this.moreActions.filter(x =>
        (x.machine === undefined || x.machine === machine) &&
        (x.role === undefined || this.accessRole(x.role)) &&
        (x.module === undefined || this.canRead(x.module)) &&
        (x.condition === undefined || x.condition(vehicle))
      );
    },

    getLocationPlace(vehicle) {
      if (vehicle.location !== null && vehicle.location !== undefined && vehicle.location.place !== null)
        return utils.formatLocation(vehicle.location.place);
      else
        return "-";
    },

    getLocationPlaceFlag(vehicle) {
      if (vehicle.location !== null && vehicle.location !== undefined)
        return vehicle.location.countryCode;
      else
        return "";
    },

    getDriver(vehicle) {
      if (this.isDriver(vehicle)) {
        if (vehicle.ride.driver !== null)
          return vehicle.ride.driver.firstName + " " + vehicle.ride.driver.lastName;
        else if (vehicle.ride.driverCode !== null)
          return vehicle.ride.driverCode;
      }

      return "";
    },

    isDriver(vehicle) {
      return vehicle.ride !== null && (vehicle.ride.driver !== null || (vehicle.ride.driverIdentification !== null && vehicle.ride.driverCode !== null));
    }
  },

  watch: {
    vehicleFilter: function() {
      this.$store.dispatch("online/filterVehicles", this.vehicleFilter);
    }
  },

  computed: {
    filteredVehicles() {
      return this.$store.state.online.filteredVehicles;
    }
  }
};
</script>

<style lang="sass" scoped>
.list-item-content
  padding: 4px 0 !important

.icon
  padding: 0 5px 0 0 !important
  color: steelblue !important

.list-item-content-edit
  padding: 4px 0 10px 0 !important

.list-item-subtitle
  padding: 3px 1px 0 0 !important
  font-size-adjust: 0.48

.small-flag-move
  margin: -14px -20px !important

.vname
  font-size: 80%
  color: gray

.service_notice
  background-color: grey
  color: white
  padding: 1px 6px
  margin: 0 1px
  border-radius: 7px
  font-size: 90%

.service_warning
  background-color: #c06432
  color: white
  padding: 1px 6px
  margin: 0 1px
  border-radius: 7px
  font-size: 90%

.flag_panic
  background-color: #c06432
  color: white
  padding: 1px 6px
  margin: 0 1px
  border-radius: 7px
  font-size: 90%

.flag_door
  background-color: grey
  color: white
  padding: 1px 6px
  margin: 0 1px
  border-radius: 7px
  font-size: 90%

</style>